export default "__VITE_ASSET__675e9ebe__"